import { addListener } from "@grindex-common/helpers/domManipulation";
import { apiConfig } from "@grindex-common/helpers/apiConfig";
import DateFilterDom from "./dateFilter.dom";

const SELECTOR_CLOSE_BUTTON = "a.clear-button";

const CLASS_VISIBLE = "visible";
const CLASS_START_DATE = "start-date";
const CLASS_END_DATE = "end-date";

const ATTRIBUTE_MINDATE = "minDate";
const ATTRIBUTE_MAXDATE = "maxDate";

const EVENT_CLICK = "click";
const EVENT_CHANGE = "change";

const TODAY = "today";

function init($views) {
	const $module = $views[0];
	const dom = new DateFilterDom($module);
	const language = apiConfig.apiLanguage;
	const isArchive = window.config.search.isArchive;
	const $defaultMaxDate = isArchive === "True" ? TODAY : null;
	const $defaultMinDate = isArchive === "True" ? null : TODAY;
	const $siteHeader = document.querySelector("header");
	const $filterPanel = document.querySelector(".facet-container");

	let $startDateCalendar;
	let $endDateCalendar;
	let startDate = dom.getStartDateElement().value;
	let endDate = dom.getEndDateElement().value;

	configCalendar();
	initEvents();

	function initEvents() {
		addListener(dom.getSubmitButton(), EVENT_CLICK, searchDate);
		addListener(dom.getDateInputElements(), EVENT_CLICK, inputReadOnly);
		addListener(dom.getDateInputButtonElements(), EVENT_CLICK, toggleCalendar);
		addListener(dom.getStartDatePickerElement(), EVENT_CHANGE, setEndMinValue);
		addListener(dom.getEndDatePickerElement(), EVENT_CHANGE, setStartMaxValue);
	}

	function searchDate(e) {
		e.preventDefault();
		if (e.type !== EVENT_CLICK) {
			return false;
		}

		toggleFilterPanel(e);
	}

	function toggleFilterPanel(e) {
		e.preventDefault();
		if ($siteHeader.classList.contains("mobile")) {
			$filterPanel.classList.toggle("open");
		}
	}

	function setCalendarOptions() {
		return {
			wrap: true,
			clickOpens: false,
			disableMobile: true,
			locale: language ? language : "en",
			maxDate: $defaultMaxDate,
			minDate: $defaultMinDate,
			onValueUpdate: function (_selectedDates, _dateStr, instance) {
				instance.element.querySelector(SELECTOR_CLOSE_BUTTON).classList.add(CLASS_VISIBLE);
			},
		};
	}

	function configCalendar() {
		const pickrOptions = setCalendarOptions();
		$startDateCalendar = dom.getStartDatePickerElement().flatpickr(pickrOptions);
		$endDateCalendar = dom.getEndDatePickerElement().flatpickr(pickrOptions);
	}

	function ensureCalendarObject() {
		if (!$startDateCalendar.config || !$endDateCalendar.config) {
			this.configCalendar();
		}
	}

	function inputReadOnly(e) {
		e.preventDefault();
		toggleCalendar(e);
	}

	function toggleCalendar(e) {
		ensureCalendarObject();
		const current = e.currentTarget.parentElement;

		e.preventDefault();

		if (current.classList.contains(CLASS_START_DATE)) {
			$endDateCalendar.close();
			$startDateCalendar.toggle();
		} else if (current.classList.contains(CLASS_END_DATE)) {
			$startDateCalendar.close();
			$endDateCalendar.toggle();
		}
	}

	function setEndMinValue() {
		const currentStartDate = dom.getStartDateElement().value;

		if (startDate !== currentStartDate) {
			startDate = currentStartDate;
			ensureCalendarObject();
			if (!currentStartDate) {
				$endDateCalendar.set(ATTRIBUTE_MINDATE, $defaultMinDate);
				return;
			}
			$endDateCalendar.set(ATTRIBUTE_MINDATE, startDate);
		}
	}

	function setStartMaxValue() {
		const currentEndDate = dom.getEndDateElement().value;

		if (endDate !== currentEndDate) {
			endDate = currentEndDate;
			ensureCalendarObject();
			if (!currentEndDate) {
				$startDateCalendar.set(ATTRIBUTE_MAXDATE, $defaultMaxDate);
				return;
			}
			$startDateCalendar.set(ATTRIBUTE_MAXDATE, endDate);
		}
	}
}

export default {
	view: "dateFilter",
	init,
};
